import * as yup from "yup";

export const schema = yup.object().shape({
  englishName: yup.string().required("Required"),
  arabicName: yup.string().required("Required"),
  email: yup.string().email("Invalid email").required("Required"),
  nationalId: yup.string(),
  phone: yup
    .string()
    .required("Required")
    .matches(
      /^\+[1-9]\d{7,14}$/,
      "Phone number must be in valid format (e.g. +966512345678)",
    ),
  location: yup
    .object()
    .shape({
      id: yup.string().required("Required"),
      nameEn: yup.string(),
    })
    .required("Required"),
});

export interface FormInputs extends yup.InferType<typeof schema> {}
